import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterBySorting,
  setFilterStatus,
} from "../../features/filter/filterSlice";

const Aside = () => {
  const dispatch = useDispatch();
  const {status} = useSelector((state) => state.filter);

  const handleSort = (e) => {
    const { value } = e.target;
    dispatch(setFilterBySorting(value));
  };

  const handleFilter = (value) => {
    dispatch(setFilterStatus(value));
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
            onChange={(e) => handleSort(e)}
          >
            <option value="default">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            {/* <!-- handle filter on button click --> */}
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                className="radio"
                onChange={() => handleFilter("all")}
                checked={status === "all"}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                className="radio"
                onChange={() => handleFilter("saved")}
                checked={status === "saved"}
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Aside;
